import React from 'react'

function linkedCustomer(props) {
  const fillColor = props.isDarkMode ? '#b3b3b3' : '#464646';
  return (
    <div style={{ 'paddingLeft': '15px', 'paddingRight': '10px' }}>
      <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 18 18" width="18">
        <defs>
          <style>
            {`.fill {
          fill: ${fillColor};
        }`}
          </style>
        </defs>
        <rect id="Canvas" fill="#ff13dc" opacity="0" width="18" height="18" /><path className="fill" d="M8.6155,14.206a4.121,4.121,0,0,1-1.653-.2935c-.26.26-.75.7735-.8565.881a2.05061,2.05061,0,0,1-2.9-2.9L6.8,8.3a2.29247,2.29247,0,0,1,1.683-.646,1.96952,1.96952,0,0,1,1.339.556,3.14668,3.14668,0,0,1,.2615.3045,3.32005,3.32005,0,0,1,1.011-1.0285,3.20739,3.20739,0,0,0-.25-.297,3.6555,3.6555,0,0,0-5.13.024l-3.595,3.593A3.5875,3.5875,0,0,0,7.185,15.887,3.93448,3.93448,0,0,1,8.6155,14.206Z" />
        <path className="fill" d="M11.861,3.2395a2.05061,2.05061,0,1,1,2.9,2.9l-.905.9045a3.18541,3.18541,0,0,1,1.426.75l.568-.5675A3.58963,3.58963,0,0,0,10.7735,2.15c-.1925.1925-2.132,2.111-2.6755,2.6545a4.15006,4.15006,0,0,1,1.871.3035C10.2295,4.85,11.7535,3.347,11.861,3.2395Z" />
        <path className="fill" d="M9.5785,11.761a4.33664,4.33664,0,0,1-.118-.9325c0-.169.024-.326.039-.4875A1.97052,1.97052,0,0,1,8.166,9.7885a2.07953,2.07953,0,0,1-.6205-.8125,1.02024,1.02024,0,0,0-.214.159l-.818.856a3.58192,3.58192,0,0,0,.6135.8365A3.403,3.403,0,0,0,9.5785,11.761Z" />
        <path className="fill" d="M14.334,14.1135V13.421a.479.479,0,0,1,.122-.309,3.65856,3.65856,0,0,0,.832-2.283c0-1.7275-.9165-2.693-2.3-2.693s-2.3265,1.0035-2.3265,2.693a3.7,3.7,0,0,0,.8715,2.283.479.479,0,0,1,.122.3095v.6895a.476.476,0,0,1-.415.48c-2.7815.242-3.216,2.1445-3.216,2.895,0,.0835.01.4115.016.4935h9.9215s.0085-.41.0085-.4935c0-.719-.4915-2.615-3.2225-2.8925A.478.478,0,0,1,14.334,14.1135Z" />
      </svg>
    </div>
  )
}

export default linkedCustomer
